import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { bankAccountsApi } from 'src/Services/API';
import { trackBankBalanceDeleted } from 'src/Services/Mixpanel/events';

type DeleteBankAccountBalanceParams = {
  bankAccountId: string;
  balanceId: string;
};

export const useDeleteBankAccountBalance = (
  options?: UseMutationOptions<void, unknown, DeleteBankAccountBalanceParams>
) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<void, unknown, DeleteBankAccountBalanceParams>(
    ['delete-bank-account-balance', assetId],
    async ({ bankAccountId, balanceId }: DeleteBankAccountBalanceParams) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await bankAccountsApi.bankAccountsControllerDeleteBalance(
        bankAccountId,
        assetId,
        balanceId
      );
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(['fetch-bank-accounts', assetId]);
        queryClient.invalidateQueries(['fetch-bank-account-balances', variables.bankAccountId]);
        trackBankBalanceDeleted({ bank_account_id: variables.bankAccountId });
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
